module.exports = __webpack_public_path__ + "images/category_lp/retro_game/assessment_achievements/5_a0263b7b41eda29c6c041e279a5eacff.png";